<template>
  <div class="tabs">
    <div class="tab-nav">
      <div :class="{ selected: selected === 0 }" @click="selected = 0">{{ $t("pageTabs.first") }}</div>
      <div :class="{ selected: selected === 1 }" @click="selected = 1">{{ $t("pageTabs.second") }}</div>
    </div>
    <div class="slot">
      <slot v-if="selected === 0" name="first"></slot>
      <slot v-if="selected === 1" name="second"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageTabs",
  data() {
    return {
      selected: 0
    };
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";
.tabs {
  align-self: stretch;
  min-height: 100%;
  max-width: 600px;
  margin: 60px 0 35px 80px;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  .tab-nav {
    display: flex;
    flex-direction: row;
    margin-bottom: 40px;
    div {
      cursor: pointer;
      border-bottom: 1px solid #BBB;
      width: 170px;
      text-align: left;
      font-size: 18px;
      padding: 0 10px 15px 10px;
      color: $color-gray;
    }
    .selected {
      border-bottom: 3px solid $color-primary;
      color: $color-black;
    }
  }
  .slot {
    display: flex;
    flex: 1 1 auto;
  }
}
@media only screen and (max-width: $screen-xs) {
  .tabs {
    flex: 1 1 auto;
    margin-left: 0;
    .tab-nav {
      margin-bottom: 0;
      div {
        width: 50%;
        font-size: 15px;
      }
    }
  }
}
</style>
